function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Close",
  transform: "translate(14 -7.939)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon",
  transform: "translate(76.598 9)",
  opacity: 0.5
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_101",
  "data-name": "Line 101",
  x2: 24,
  y2: 24,
  fill: "none",
  stroke: "#343638",
  strokeLinecap: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_110",
  "data-name": "Line 110",
  y1: 24,
  x2: 24,
  fill: "none",
  stroke: "#343638",
  strokeLinecap: "round",
  strokeWidth: 1.5
})), /*#__PURE__*/React.createElement("text", {
  id: "Schliessen",
  transform: "translate(67 25.5)",
  fill: "#343638",
  fontSize: 13,
  fontFamily: "NunitoSans-ExtraBold, Nunito Sans",
  fontWeight: 800,
  opacity: 0.5
}, /*#__PURE__*/React.createElement("tspan", {
  x: -80.457,
  y: 0
}, "SCHLIESSEN")));

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115.659,
    height: 26.121,
    viewBox: "0 0 115.659 26.121",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.d08f689c.svg";
export { ForwardRef as ReactComponent };